import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { HttpClient } from '@angular/common/http';
import { Location } from '@angular/common';
import { TableModule } from 'primeng/table';
import { ButtonModule } from 'primeng/button';
import { RippleModule } from 'primeng/ripple';
import { ToastModule } from 'primeng/toast';
import { ToolbarModule } from 'primeng/toolbar';
import { RatingModule } from 'primeng/rating';
import { InputTextModule } from 'primeng/inputtext';
import { TextareaModule } from 'primeng/textarea';
import { SelectModule } from 'primeng/select';
import { RadioButtonModule } from 'primeng/radiobutton';
import { InputNumberModule } from 'primeng/inputnumber';
import { DialogModule } from 'primeng/dialog';
import { TagModule } from 'primeng/tag';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ContextMenuModule } from 'primeng/contextmenu';
import { AutoCompleteModule } from 'primeng/autocomplete';
import { UserService } from '../pages/service/user.service';
import { MessageService } from 'primeng/api';
import { environment } from '../../environments/environment';
import { LoaderService } from '../services/loader.service';
@Component({
  selector: 'app-generate-combine-picking-list',
  imports: [
    AutoCompleteModule,
    RouterModule,
    CommonModule,
    TableModule,
    FormsModule,
    ButtonModule,
    ContextMenuModule,
    RippleModule,
    ToastModule,
    ToolbarModule,
    RatingModule,
    InputTextModule,
    TextareaModule,
    SelectModule,
    RadioButtonModule,
    InputNumberModule,
    DialogModule,
    TagModule,
    InputIconModule,
    IconFieldModule,
    ConfirmDialogModule,
  ],
  templateUrl: './generate-combine-picking-list.component.html',
  styleUrls: ['./generate-combine-picking-list.component.scss'],
  providers: [MessageService]
})
export class GenerateCombinePickingListComponent implements OnInit {
  item: any;
  itemList: any[] = [];
  totalAmountAfterDiscount = 0;
  @ViewChild('combinePickingList') combinePickingListElement!: ElementRef;
  div1: string = '';
  supplierDetails = {
    supplerVrno: '',
    coa1: '',
    phno: '',
    coa2: '',
    coa3: '',
    coa4: ''
  };
  customerDetails = {
    customerVrno: '',
    CUA1: '',
    CUA2: '',
    CUA3: '',
    CUA4: '',
    PONO: ''
  };
  pickingListDetails = {
    customerNo: '',
    date: '',
    orderNumber: '',
    referenceOrderNumber: ''
  };
  lineDetails: any[] = [];
  itemsPerPage = 26;
  currentPage = 1;

  paginatedContent: any[][] = [];
  summary = {
    grossValue: 0,
    totalDiscountValue: 0,
    vatAmount: 0,
    totalOrderValue: 0
  };

  divisionId: string = '';
  combinePickingLists: any[] = [];
  isLoading: boolean = false;
  pickingListType: string = '';
  fromDate: string = '';
  toDate: string = '';
  orderStatus: number | null = null;

  combinePickingListInfo: any = {};
  combineLineDetails: any[] = [];
  combineSummary: any = {};

  labelMap: {
    [lang in 'en' | 'de' | 'nl']: { [key: string]: string }
  } = {
    en: {
      combinedPickingListTitle: 'Combined Picking List',
      from: 'From',
      to: 'To',
      status: 'Status',
      lineNo: 'Line No',
      itemNo: 'Item No.',
      quantity: 'Quantity',
      itemName: 'Item Name',
      pcs: 'Pcs',
      size: 'Size',
      totalPackedQty: 'Total Packed Qty:',
      totalGrossWeight: 'Total Gross Weight:',
      totalNetWeight: 'Total Net Weight:'
    },
    de: {
      combinedPickingListTitle: 'Kombinierte Kommissionierliste',
      from: 'Von',
      to: 'Bis',
      status: 'Status',
      lineNo: 'Zeilennr.',
      itemNo: 'Artikel-Nr.',
      quantity: 'Menge',
      itemName: 'Artikelname',
      pcs: 'Stk.',
      size: 'Größe',
      totalPackedQty: 'Gesamt verpackte Menge:',
      totalGrossWeight: 'Gesamtbruttogewicht:',
      totalNetWeight: 'Gesamtnettogewicht:'
    },
    nl: {
      combinedPickingListTitle: 'Gecombineerde Picklijst',
      from: 'Van',
      to: 'Tot',
      status: 'Status',
      lineNo: 'Regel nr.',
      itemNo: 'Artikel nr.',
      quantity: 'Aantal',
      itemName: 'Artikelnaam',
      pcs: 'Stuks',
      size: 'Maat',
      totalPackedQty: 'Totaal verpakt aantal:',
      totalGrossWeight: 'Totaal brutogewicht:',
      totalNetWeight: 'Totaal nettogewicht:'
    }
  };

  selectedLanguage: 'en' | 'de' | 'nl' = 'en'; // Add this type annotation

  constructor(
    private http: HttpClient,
    private router: Router,
    private userService: UserService,
    private location: Location,
     private loaderService: LoaderService,
    private messageService: MessageService // <-- Add this line
  ) {
    const nav = this.router.getCurrentNavigation();
    const state = nav?.extras?.state as any;
    this.pickingListType = state?.pickingListType || '';
    this.fromDate = state?.fromDate || '';
    this.toDate = state?.toDate || '';
    this.orderStatus = state?.orderStatus ?? null;
  }

  goBack() {
    if (window.history.length > 1) {
      this.location.back();
    } else {
      this.router.navigate(['/Orders1']);
    }
  }

  ngOnInit() {
    const companyId = this.userService.getCompanyId() || '';
    const divisionId = this.userService.getDivisionId() || '';
    this.div1 = divisionId;
    if (this.pickingListType && this.fromDate && this.toDate) {
      this.fetchCombinedPickingList(companyId, divisionId, this.fromDate, this.toDate, this.pickingListType, this.orderStatus);
    }
  }

  chunkData(data: any[], size: number): any[][] {
    const chunks = [];
    for (let i = 0; i < data.length; i += size) {
      chunks.push(data.slice(i, i + size));
    }
    return chunks;
  }

  getTotalAmountAfterDiscount(): number {
    return this.itemList.reduce((sum, item) => sum + item.amountAfterDiscount, 0);
  }
  getGrossValue(): number {
    return (this.itemList || []).reduce((sum, row) => sum + (Number(row.amount) || 0), 0);
  }
  getTotalDiscountValue(): number {
    return (this.itemList || []).reduce((sum, row) => sum + (Number(row.amount) * Number(row.discount) / 100 || 0), 0);
  }
  getNetAmount(): number {
    return (this.itemList || []).reduce((sum, row) => sum + (Number(row.amountAfterDiscount) || 0), 0);
  }
  getVatAmount(): number {
    return (this.itemList || []).reduce((sum, row) => sum + (Number(row.vatAmount) || (Number(row.amountAfterDiscount) * Number(row.vat) / 100) || 0), 0);
  }
  getOrderValue(): number {
    return this.getNetAmount() + this.getVatAmount();
  }
  getTotalQuantity(): number {
    return this.lineDetails.reduce((sum, line) => sum + (Number(line.quantity) || 0), 0);
  }
  getTotalGrossWeight(): number {
    return this.lineDetails.reduce((sum, line) => sum + (Number(line.grossWeight) || 0), 0);
  }
  getTotalNetWeight(): number {
    return this.lineDetails.reduce((sum, line) => sum + (Number(line.netWeight) || 0), 0);
  }

  printCombinePickingList() {
    const printContents = this.combinePickingListElement.nativeElement.innerHTML;
    const styles = Array.from(document.querySelectorAll('style, link[rel="stylesheet"]'))
      .map(node => node.outerHTML)
      .join('\n');
    const popupWin = window.open('', '_blank', 'width=1000,height=800');
    if (popupWin) {
      popupWin.document.open();
      popupWin.document.write(`
        <html>
          <head>
            <title>Combine Picking List</title>
            ${styles}
            <style>
              body { background: #fff !important; }
              .invoice-wrapper { box-shadow: none !important; border-radius: 0 !important; margin: 0 !important; padding: 0 !important; width: 100% !important; }
              .p-toolbar, .p-button-sm, .p-button-secondary { display: none !important; }
            </style>
          </head>
          <body onload="window.print(); window.close();">
            ${printContents}
          </body>
        </html>
      `);
      popupWin.document.close();
    }
  }

    exportToPDF() {
        this.messageService.add({
            severity: 'success',
            summary: 'Exporting to PDF',
            detail: 'Please wait while the invoice is being prepared for PDF export.',
            life: 3000
        });

        const element = this.combinePickingListElement.nativeElement;
        element.classList.add('pdf-export'); // Add class for PDF styling

        // Get all invoice pages
        const wrappers: HTMLElement[] = Array.from(element.querySelectorAll('.invoice-wrapper'));
        const pdf = new jsPDF('p', 'mm', 'a4');
        const pageWidth = pdf.internal.pageSize.getWidth();
        const pageHeight = pdf.internal.pageSize.getHeight();

        // Helper to render each page
        const renderPage = (idx: number) => {
            if (idx >= wrappers.length) {
                pdf.save('proformaInvoice.pdf');
                element.classList.remove('pdf-export');
                return;
            }
            html2canvas(wrappers[idx], { scale: 2 }).then((canvas) => {
                const imgData = canvas.toDataURL('image/jpeg', 1.0);
                const imgProps = pdf.getImageProperties(imgData);
                const imgWidth = pageWidth;
                const imgHeight = (imgProps.height * imgWidth) / imgProps.width;

                if (idx > 0) pdf.addPage();
                pdf.addImage(imgData, 'JPEG', 0, 0, imgWidth, imgHeight > pageHeight ? pageHeight : imgHeight);

                renderPage(idx + 1);
            });
        };

        renderPage(0);
    }
  fetchCombinedPickingList(
    companyId: string,
    divisionId: string,
    fromDate: string,
    toDate: string,
    pickingListType: string,
    orderStatus: number | null
  ) {
 
    this.loaderService.show('Loading combined picking list...','Please wait...');
    let url = `${environment.apiUrl}InvoiceAndPicklist/GeneratePicklist?company=${companyId}&division=${divisionId}&fromDate=${fromDate}&toDate=${toDate}&pickingListType=${pickingListType}`;
    if (orderStatus !== null && orderStatus !== undefined) {
      url += `&orderStatus=${orderStatus}`;
    }
    this.http.get<any>(url).subscribe(
      (response) => {
        this.combinePickingListInfo = response?.dateAndStatus || {};
        this.combineLineDetails = response?.lineDetails || [];
        this.combineSummary = response?.summaryLevelData || {};
     setTimeout(() => {
        this.loaderService.hide();
      }, 300);
      },
      (error) => {
        console.error('Error fetching combined picking list:', error);
        this.loaderService.hide();
      }
    );
  }

  get totalPages(): number {
    return Math.ceil(this.combineLineDetails.length / this.itemsPerPage);
  }

  get paginatedCombineContent(): any[][] {
    const chunks = [];
    for (let i = 0; i < this.combineLineDetails.length; i += this.itemsPerPage) {
      chunks.push(this.combineLineDetails.slice(i, i + this.itemsPerPage));
    }
    return chunks;
  }

  prevPage() {
    if (this.currentPage > 1) this.currentPage--;
  }

  nextPage() {
    if (this.currentPage < this.totalPages) this.currentPage++;
  }


  getLabel(key: string): string {
    const lang = this.selectedLanguage as keyof typeof this.labelMap;
    return this.labelMap[lang]?.[key] ?? key;
  }
}
